
import { Icon } from '@/components/ui/Icon'
import { useUiMode } from '@/components/workspace/UiModeProvider'
import { cx } from '@/lib/ui'

/**
 * Simple or Advanced, in the account menu.
 *
 * Deliberately not buried in Settings. Someone who opens ROUTR for the first
 * time and finds it too thin has to be able to get at the rest in seconds, or
 * the default we chose becomes a wall rather than a starting point.
 */
export function ModeToggle() {
  const { advanced, setMode } = useUiMode()
  return (
    <button
      type="button"
      onClick={() => setMode(advanced ? 'SIMPLE' : 'ADVANCED')}
      className="flex w-full items-start gap-2 rounded-xl px-2.5 py-2 text-left text-sm transition-colors hover:bg-hover"
      aria-pressed={advanced}
    >
      <Icon name={advanced ? 'eye' : 'eyeOff'} className="mt-0.5 h-4 w-4 shrink-0 text-muted" />
      <span>
        <span className="block">{advanced ? 'Advanced view' : 'Simple view'}</span>
        <span className={cx('block text-[11px] leading-snug text-muted')}>
          {advanced
            ? 'Showing circuits, connectors, formats and cable specs. Tap for less.'
            : 'Hiding the broadcast detail. Tap for connectors, formats and circuits.'}
        </span>
      </span>
    </button>
  )
}
